const BrowserLogger = require('alife-logger')
import { getToken } from '@/utils/storage'

export let __bl = null
export function getEnv() {
  let env = 'prod'
  const domain = window.location.host
  if (domain.indexOf('localhost') > -1) {
    env = 'local'
  } else if (process.env.VUE_APP_BUILD_ENV === 'dev') {
    env = 'daily'
  } else if (process.env.VUE_APP_BUILD_ENV === 'pre') {
    env = 'pre'
  }
  return env
}

export function parseUid(token = getToken()) {
  let uid = ''
  if (token) {
    const tokenStr = token.split('_')
    uid = tokenStr[1] || ''
  }
  return uid
}

export function setUid(uid) {
  if (!__bl) return
  __bl.setConfig({
    uid
  })
}

export function setUserType(userType) {
  if (!__bl) return
  __bl.setConfig({
    tag: userType
  })
}

export function loadARMS() {
  if (!__bl) {
    __bl = BrowserLogger.singleton(
      {
        pid: 'b7z525alis@70c4b671e2849bd',
        appType: 'web',
        imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
        sendResource: true,
        enableLinkTrace: true,
        behavior: true,
        enableSPA: true,
        useFmp: true,
        environment: getEnv(),

        /**
         * 配置API过滤规则
         * 过滤媒体文件（视频、音频）的错误，这些应该作为资源错误而非API错误上报
         */
        ignore: {
          ignoreApis: [
            // 使用正则表达式过滤所有媒体文件
            /\.flv(\?.*)?$/i,           // FLV 视频文件
            /\.mp4(\?.*)?$/i,           // MP4 视频文件
            /\.m3u8(\?.*)?$/i,          // HLS 播放列表
            /\.ts(\?.*)?$/i,            // HLS 分片文件
            /\.webm(\?.*)?$/i,          // WebM 视频文件
            /\.avi(\?.*)?$/i,           // AVI 视频文件
            /\.mov(\?.*)?$/i,           // MOV 视频文件
            /\.wmv(\?.*)?$/i,           // WMV 视频文件
            /\.mkv(\?.*)?$/i,           // MKV 视频文件
            /\.mp3(\?.*)?$/i,           // MP3 音频文件
            /\.wav(\?.*)?$/i,           // WAV 音频文件
            /\.aac(\?.*)?$/i,           // AAC 音频文件
            /\.ogg(\?.*)?$/i,           // OGG 音频文件

            // 也可以使用函数进行更复杂的过滤
            function(url) {
              // 过滤特定的播放域名
              if (url && url.includes('play.yaomaitong.cn')) {
                // 如果是媒体文件请求，返回 true（过滤）
                return /\.(flv|mp4|m3u8|ts|webm|avi|mov|wmv|mkv|mp3|wav|aac|ogg)$/i.test(url)
              }
              return false // 其他正常上报
            }
          ],
          ignoreErrors: /^Script error\.?$/
        },

        /**
         * 解析API响应数据
         * @param {Object} res - HTTP响应对象
         * @param {number} res.code - 响应状态码
         * @param {string} res.msg - 响应消息
         * @param {Object} res.data - 响应消息
         * @returns {Object} 解析后的响应结果
         * @returns {string} returns.msg - 响应消息
         * @returns {number} returns.code - 响应状态码
         * @returns {boolean} returns.success - 请求是否成功
         */
        parseResponse: res => {
          if (!res || typeof res !== 'object') return {}
          const { msg, code } = res
          // 与request.js中的成功判断保持一致：code === 0 表示成功
          const success = code === 0

          return { msg, code, success }
        }
      }
    )
  }
  return __bl
}

export function logError(name = 'CustomErrorLog', message) {
  if (['c5dadf7b6be082c897f768957341dd90', 'e2e2968bfc600217840be163804d93f5', 'c01e1e61c08d4471b945df8baffb6419']?.includes(parseUid())) {
    __bl?.error({name, message}, {
      filename: 'LiveExam.vue'
    })
  }
}
